import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <span
              className="text-xl font-heading tracking-wide bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent"
            >
              飞飞漫画
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-100/70'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg transition-colors duration-200 hover:bg-background-200 whitespace-nowrap cursor-pointer flex items-center gap-1">
                分类浏览
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </div>
              </button>
              <div className="absolute top-full left-0 mt-1 w-56 bg-background-50 rounded-lg border border-background-200/80 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2">
                <div className="grid grid-cols-2 gap-1 px-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-2 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors duration-150 whitespace-nowrap cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className={`${cat.icon} text-xs`}></i>
                      </div>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-100/70'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <div className="relative">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-search-line text-lg text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors"></i>
              </div>
            </div>
          </div>

          <button
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-200 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-foreground-700`}></i>
            </div>
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-screen bg-background-50/98 backdrop-blur-md' : 'max-h-0'
        }`}
      >
        <div className="px-4 py-4 flex flex-col gap-1">
          <Link
            to="/"
            className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/'
                ? 'text-primary-600 bg-primary-100/70'
                : 'text-foreground-700 hover:bg-background-200'
            }`}
          >
            首页
          </Link>
          <div className="px-4 py-2 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
            分类浏览
          </div>
          <div className="grid grid-cols-2 gap-1 px-2">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-2 py-3 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/about'
                ? 'text-primary-600 bg-primary-100/70'
                : 'text-foreground-700 hover:bg-background-200'
            }`}
          >
            关于我们
          </Link>
        </div>
      </div>
    </nav>
  );
}